<template>
  <page-outline :title="$t('pain008.list_trans_file')">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            filterType="list"
            :mode="this.mode"
            @refreshInbox="refreshInbox()"
            @applyFilter="applyFilter($event)"
            propedServiceId="9"
            :countResult="paginationObject.nbResultsTotal.toString()">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow: hidden">

        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="9"
                  :countResult="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br/>

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100"/>
              </b-col>
            </b-row>

            <br />

            <b-row class="form-group justify-content-start m-0 p-0">
              <b-col md="2" cols="6" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'list', 'inactive-tab': currentTab !== 'list'}"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="choseTable('list')">
                  <i class="fa-duotone fa-file"></i>
                  {{ $t('pain008.list_import_file') }}
                </div>
              </b-col>
              <b-col md="2" cols="6" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'data', 'inactive-tab': currentTab !== 'data'}"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="choseTable('data')">
                  <i class="fa-duotone fa-file-lines"></i>
                  {{ $t('pain008.data_select_file') }}
                </div>
              </b-col>
              <b-col md="2" class="m-0 p-0 mb-2">
                <div :class="{ 'active-tab': currentTab === 'details', 'inactive-tab': currentTab !== 'details'}"
                  class="mr-2 text-center cursor"
                  size="sm"
                  @click="choseTable('details')">
                  <i class="fa-duotone fa-grid"></i>
                  {{ $t('pain008.detail_select_file') }}
                </div>
              </b-col>
              <!-- <b-col sm="2" class="m-0 p-0">
                <div :class="{ 'active-tab': currentTab === 'historique', 'inactive-tab': currentTab !== 'historique'}" class="mr-2 text-left cursor" size="sm"
                  v-on:click="choseTable('historique')">
                  <i class="fa-duotone fa-clock-rotate-left"></i>
                  {{ $t('pain008.history_modi') }}
                </div>
              </b-col> -->
            </b-row>

            <br>

            <!-- Tableau des fichiers importés-->
            <spinner v-if="activateSpinner"></spinner>
            <div v-else-if="currentTab === 'list'">
              <b-table hover responsive
              v-if="items.length"
              class="mt-3"
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDir"
              @head-clicked="sortTable"
              ref="tablePain008Close"
              :id="'table' + '-' + randomString">

                <template #cell(fileImport)="row">
                  <!-- <div @click="row.item._showDetails ? row.toggleDetails : ''" class="d-flex justify-content-between">
                    <span>
                      {{ row.item.fileImport }} &nbsp;&nbsp;
                    </span>
                    <div v-if="row.item.detailsOK.length > 0 || row.item.detailsKO.length > 0" class="cursor">
                      <i v-if="row.item._showDetails" class="fa-solid fa-caret-up text-primary"></i>
                      <i v-else class="fa-solid fa-caret-down"></i>
                    </div>
                  </div> -->
                  <div v-if="checkStatus(row.item.globalState)" @click="showData(row.item.IdFile, row.index)" class="cursor">
                    <div class="text-left" v-if="(row.item.fileImport.length > 27)">
                      {{ row.item.fileImport.substr(0,27)+ '...' }}
                    </div>
                    <div class="text-left" v-else>{{row.item.fileImport}}</div>
                  </div>
                  <div v-else>
                    <div class="text-left" v-if="(row.item.fileImport.length > 27)">
                      {{ row.item.fileImport.substr(0,27)+ '...' }}
                    </div>
                    <div class="text-left" v-else>{{row.item.fileImport}}</div>
                  </div>
                </template>
                <template #cell(dateImport)="row_d">
                  <div v-if="checkStatus(row_d.item.globalState)" @click="showData(row_d.item.IdFile, row_d.index)" class="cursor">
                    {{ row_d.item.dateImport }}
                  </div>
                  <div v-else>
                    {{ row_d.item.dateImport }}
                  </div>
                </template>
                <!-- <template #cell(nbTotalElem)="row_nbe">
                  <div @click="showData(row_nbe.item.idFile)" class="cursor">{{ row_nbe.item.nbTotalElem }} </div>
                </template> -->
                <template #cell(total)="row_tot">
                  <div v-if="checkStatus(row_tot.item.globalState)" @click="showData(row_tot.item.IdFile, row_tot.index)" class="cursor">
                    {{ row_tot.item.total }}
                  </div>
                  <div v-else>
                    {{ row_tot.item.total }}
                  </div>
                </template>
                <template #cell(erro)="row_error">
                  <div v-if="checkStatus(row_error.item.globalState)" @click="showData(row_error.item.IdFile, row_error.index)" class="cursor">
                    {{ row_error.item.erro }}
                  </div>
                  <div v-else>
                    {{ row_error.item.erro }}
                  </div>
                </template>
                <template #cell(validated)="row_validated">
                  <div v-if="checkStatus(row_validated.item.globalState)" @click="showData(row_validated.item.IdFile, row_validated.index)" class="cursor">
                    {{ row_validated.item.validated }}
                  </div>
                  <div v-else>
                    {{ row_validated.item.validated }}
                  </div>
                </template>
                <template #cell(process)="row_process">
                  <div v-if="checkStatus(row_process.item.globalState)" @click="showData(row_process.item.IdFile, row_process.index)" class="cursor">
                    {{ row_process.item.process }}
                  </div>
                  <div v-else>
                    {{ row_process.item.process }}
                  </div>
                </template>
                <template #cell(verif)="row_verif">
                  <div v-if="checkStatus(row_verif.item.globalState)" @click="showData(row_verif.item.IdFile, row_verif.index)" class="cursor">
                    {{ row_verif.item.verif }}
                  </div>
                  <div v-else>
                    {{ row_verif.item.verif }}
                  </div>
                </template>
                <template #cell(refus)="row_refus">
                  <div v-if="checkStatus(row_refus.item.globalState)" @click="showData(row_refus.item.IdFile, row_refus.index)" class="cursor">
                    {{ row_refus.item.refus }}
                  </div>
                  <div v-else>
                    {{ row_refus.item.refus }}
                  </div>
                </template>
                <template #cell(globalState)="row_state">
                  <div v-if="row_state.item.globalState === $t('pain008.file_refused')" class="text-danger cursor">
                    {{ row_state.item.globalState }}
                  </div>
                  <!-- <div v-else-if="row_state.item.globalState === $t('pain008.processed_pending')" @click="showData(row_state.item.IdFile, row_state.index)" class="text-muted cursor">
                    {{ row_state.item.globalState }}
                  </div> -->
                  <div v-if="checkStatus(row_state.item.globalState)" @click="showData(row_state.item.IdFile, row_state.index)" class="cursor">
                    {{ row_state.item.globalState }}
                  </div>
                  <div v-else>
                    {{ row_state.item.globalState }}
                  </div>
                </template>
                <!-- <template #cell(FolderClose)="row_close">
                  <b-row v-if="row_close.item.FolderClose !== 'Cadenas'">
                    <b-col class="cursor">
                      <div><u>{{ row_close.item.FolderClose }}</u></div>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <span class="cursor mx-auto"><i class="fa-duotone fa-lock text-muted text-center"></i></span>
                  </b-row>
                </template> -->

                <!-- <template #row-details="details_row">
                  <b-card class="bg-white border-0 shadow-none p-0 m-0">
                    <b-row v-for="x in details_row.item.detailsOK" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-success font-weight-bold">
                          {{ $t('pain008.valid_elements_reissued') }}
                        </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                    <b-row v-for="x in details_row.item.detailsKO" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-danger font-weight-bold pt-2">
                          {{ $t('pain008.rejected_elements_reissued') }}
                        </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                  </b-card>
                </template> -->
              </b-table>

              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>

              <b-row class="justify-content-end mt-5">
                <!-- <b-col lg="3" class="mt-3" v-if="items.length">
                  <i>{{ $t('pain008.click_arrow_access_details') }}</i>
                </b-col> -->
                <b-col lg="2" offset="7" class="mt-3">
                  <b-button variant="primary"
                    @click="extractCSV_items()">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col>
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </b-col>
              </b-row>

            </div>

            <!-- Tableau données du fichier sélectionné -->
            <div v-else-if="currentTab === 'data'">
              <b-tabs active-nav-item-class="active-blue font-weight-bold" v-model="tabType">
                <b-tab :title="$t('pain008.legal_person')" :active="tabType===0">
                  <b-row class="my-3 justify-content-around" v-if="this.items[this.currentIndexList]">
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #6b6aea">
                        {{ $t('pain008.imported_file') }}
                      </span>
                      <span>
                        <div v-if="(this.items[this.currentIndexList].fileImport.length > 27)">
                          {{ this.items[this.currentIndexList].fileImport.substr(0,27)+ '...' }}
                        </div>
                        <div class="text-left" v-else>{{this.items[this.currentIndexList].fileImport}}</div>
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold" style="margin-left: -60px">
                      <span>
                        {{ $t('pain008.total_2') }}
                      </span>
                      <span>
                        {{nbTotalRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: #f54336">
                        {{ $t('pain008.in_error') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbErrorRequest}}
                      </span>
                    </b-col>
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #11b1fd">
                        {{ $t('pain008.being_processed') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbBeingProcessedRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold pr-5" style="margin-left: -50px">
                      <span style="color: orange">
                        {{ $t('pain008.to_verify') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbToVerifyRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.validated') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbValidatedRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#f54336">
                        {{ $t('pain008.refused') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbRefusedRequest}}
                      </span>
                    </b-col>
                    <b-col style="margin-left: -20px">
                      <div class="requestsList">
                        <div v-if="!isSmartphoneOS">
                          <cm-messages-filter-1
                          class="researchfilter"
                          style="position: relative; z-index: 10"
                          filterType="list"
                          :mode="this.mode"
                          :randomId="randomId"
                          @applyFilter="applyFilterData($event)"
                          propedServiceId="9">
                        </cm-messages-filter-1>
                        </div>
                        <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
                      </div>
                    </b-col>
                  </b-row>

                  <div style="overflow: auto; height: 290px">
                    <b-table hover responsive
                      v-if="itemsData.length"
                      :items="itemsData"
                      :fields="fieldsDataPM"
                      :sort-by="sortField"
                      ref="tablePain008DataClose"
                      :id="'table-data' + '-' + randomString">

                      <template #head(ValidAll)>
                        <template v-if="itemsData.filter(elem => elem.StateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedValid" @change="selectAll('ValideAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.validate_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>
                      </template>

                      <template #head(RejectAll)>
                        <template v-if="itemsData.filter(elem => elem.StateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                          <b-form-checkbox v-model="allcheckedReject" @change="selectAll('RejectAll')">
                            <span style="color: var(--actionTextColorBlack)">
                              {{ $t('pain008.decline_all') }}
                            </span>
                          </b-form-checkbox>
                        </template>
                        <template v-else><span></span></template>
                      </template>

                      <template #cell(NameAccount)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.NameAccount }}
                        </div>
                      </template>
                      <template #cell(Iban)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.Iban }}
                        </div>
                      </template>
                      <template #cell(Siren)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.Siren }}
                        </div>
                      </template>
                      <template #cell(VerifIban)="row">
                        <div v-if="row.item.VerifIban == 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.VerifIban }}
                        </div>
                        <div v-else class="cursor"
                          v-html="row.item.VerifIban"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(VerifSiren)="row">
                        <div v-if="row.item.VerifSiren == 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.VerifSiren }}
                        </div>
                        <div v-else class="cursor"
                          v-html="row.item.VerifSiren"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <!-- <template #cell(Score)="row">
                        <span class="cursor" @click="showDetails(row.index)">
                          {{ row.item.Score }}
                        </span>
                      </template> -->
                      <template #cell(StateVerif)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.StateVerif }}
                        </div>
                      </template>
                      <template #cell(ValidAll)="row">
                        <template v-if="row.item.StateVerif !== $t('pain008.positive_response')">
                          <template v-if="row.item.StatusValidation === '1'">
                            <b-form-checkbox v-model="row.item.ValidAll" @change="decideLine(row, 1)">
                              <u style="color: #11b1fd; font-weight: 400">
                                {{ $t('pain008.validate') }}
                              </u>
                            </b-form-checkbox>
                          </template>
                          <template v-if="row.item.StatusValidation === '2'">
                            <div class="cursor" @click="showDetails(row.index)">
                              {{ $t('pain008.manually_validated') }}
                            </div>
                          </template>
                        </template>
                      </template>
                      <template #cell(RejectAll)="row">
                        <template v-if="row.item.StateVerif !== $t('pain008.positive_response')">
                          <template v-if="row.item.StatusValidation === '1'">
                            <b-form-checkbox v-model="row.item.RejectAll" @change="decideLine(row, 0)">
                              <u style="color: #000000; font-weight: 400">
                                {{ $t('pain008.refus') }}
                              </u>
                            </b-form-checkbox>
                          </template>
                          <template v-if="row.item.StatusValidation === '3'">
                            <div class="cursor" @click="showDetails(row.index)">
                              {{ $t('pain008.manually_denied') }}
                            </div>
                          </template>
                        </template>
                      </template>
                    </b-table>
                    <div v-else class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('common.no_result') }}
                      </span>
                    </div>
                  </div>
                  <br />
                  <b-progress height="20px" :min="min" :max="max" class="mt-3 mb-5">
                    <b-progress-bar :value="max - value"
                      :label="`${(100 - ((value * 100) / max)).toFixed(0)}%`">
                    </b-progress-bar>
                  </b-progress>
                </b-tab>
                <b-tab :title="$t('pain008.physical_person')">
                  <div class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('pain008.no_PP') }}
                    </span>
                  </div>
                  <!-- <b-row class="my-3 justify-content-around" v-if="this.items[this.currentIndexList]">
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #6b6aea">
                        {{ $t('pain008.imported_file') }}
                      </span>
                      <span>
                        <div v-if="(this.items[this.currentIndexList].fileImport.length > 27)">
                          {{ this.items[this.currentIndexList].fileImport.substr(0,27)+ '...' }}
                        </div>
                        <div class="text-left" v-else>{{this.items[this.currentIndexList].fileImport}}</div>
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold" style="margin-left: -60px">
                      <span>
                        {{ $t('pain008.total_2') }}
                      </span>
                      <span>
                        {{nbTotalRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color: #f54336">
                        {{ $t('pain008.in_error') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbErrorRequest}}
                      </span>
                    </b-col>
                    <b-col cols="2" class="mt-3 font-weight-bold">
                      <span style="color: #11b1fd">
                        {{ $t('pain008.being_processed') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbBeingProcessedRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold pr-5" style="margin-left: -50px">
                      <span style="color: orange">
                        {{ $t('pain008.to_verify') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbToVerifyRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#47d89c">
                        {{ $t('pain008.validated') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbValidatedRequest}}
                      </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">
                      <span style="color:#f54336">
                        {{ $t('pain008.refused') }}
                      </span>
                      <span style="color: #939393">
                        : {{nbRefusedRequest}}
                      </span>
                    </b-col>
                    <b-col style="margin-left: -20px">
                      <div class="requestsList">
                        <div v-if="!isSmartphoneOS">
                          <cm-messages-filter-1
                          class="researchfilter"
                          style="position: relative; z-index: 10"
                          filterType="list"
                          :mode="this.mode"
                          :randomId="randomId"
                          @applyFilter="applyFilterData($event)"
                          propedServiceId="9">
                        </cm-messages-filter-1>
                        </div>
                        <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
                      </div>
                    </b-col>
                  </b-row>
                  <div style="overflow: auto; height: 290px">
                    <b-table hover responsive
                      v-if="itemsData.length"
                      :items="itemsData"
                      :fields="fieldsDataPP"
                      :sort-by="sortField"
                      ref="tablePain008DataClose"
                      :id="'table-data' + '-' + randomString">

                      <template #head(ValidAll)>
                        <template v-if="itemsData.filter(elem => elem.StateVerif === 'Réponse négative').length">
                          <template v-if="itemsData.filter(elem => elem.StatusValidation === '1').length">
                            <b-form-checkbox v-model="allcheckedValid" @change="selectAll('ValideAll')">
                              <span style="color: #6b6aea">
                                {{ $t('pain008.validate_all') }}
                              </span>
                            </b-form-checkbox>
                          </template>
                        </template>
                        <template v-else><span></span></template>
                      </template>

                      <template #head(RejectAll)>
                        <template v-if="itemsData.filter(elem => elem.StateVerif === 'Réponse négative').length">
                          <template v-if="itemsData.filter(elem => elem.StatusValidation === '1').length">
                            <b-form-checkbox v-model="allcheckedReject" @change="selectAll('RejectAll')">
                              <span style="color: #6b6aea">
                                {{ $t('pain008.decline_all') }}
                              </span>
                            </b-form-checkbox>
                          </template>
                        </template>
                        <template v-else><span></span></template>
                      </template>

                      <template #cell(NameAccount)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.NameAccount }}
                        </div>
                      </template>
                      <template #cell(Iban)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.Iban }}
                        </div>
                      </template>
                      <template #cell(Siren)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.Siren }}
                        </div>
                      </template>
                      <template #cell(VerifIban)="row">
                        <div v-if="row.item.VerifIban == 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.VerifIban }}
                        </div>
                        <div v-else class="cursor"
                          v-html="row.item.VerifIban"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(VerifSiren)="row">
                        <div v-if="row.item.VerifSiren == 'Faux'"
                          class="cursor text-danger"
                          @click="showDetails(row.index)">
                          {{ row.item.VerifSiren }}
                        </div>
                        <div v-else class="cursor"
                          v-html="row.item.VerifSiren"
                          @click="showDetails(row.index)">
                        </div>
                      </template>
                      <template #cell(StateVerif)="row">
                        <div class="cursor" @click="showDetails(row.index)">
                          {{ row.item.StateVerif }}
                        </div>
                      </template>
                      <template #cell(ValidAll)="row">
                        <template v-if="row.item.StateVerif === 'Réponse négative'">
                          <template v-if="row.item.StatusValidation === '1'">
                            <b-form-checkbox v-model="row.item.ValidAll" @change="decideLine(row, 1)">
                              <u style="color: #11b1fd; font-weight: 400">
                                {{ $t('pain008.validate') }}
                              </u>
                            </b-form-checkbox>
                          </template>
                          <template v-if="row.item.StatusValidation === '2'">
                            <div class="cursor" @click="showDetails(row.index)">
                              {{ $t('pain008.manually_validated') }}
                            </div>
                          </template>
                        </template>
                      </template>
                      <template #cell(RejectAll)="row">
                        <template v-if="row.item.StateVerif === 'Réponse négative'">
                          <template v-if="row.item.StatusValidation === '1'">
                            <b-form-checkbox v-model="row.item.RejectAll" @change="decideLine(row, 0)">
                              <u style="color: #000000; font-weight: 400">
                                {{ $t('pain008.refus') }}
                              </u>
                            </b-form-checkbox>
                          </template>
                          <template v-if="row.item.StatusValidation === '3'">
                            <div class="cursor" @click="showDetails(row.index)">
                              {{ $t('pain008.manually_denied') }}
                            </div>
                          </template>
                        </template>
                      </template>
                    </b-table>
                    <div v-else class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('pain008.no_PP') }}
                      </span>
                    </div>
                  </div>
                  <br />
                  <b-progress height="20px" :min="min" :max="max" class="mt-3 mb-5">
                    <b-progress-bar :value="max - value"
                      :label="`${(100 - ((value * 100) / max)).toFixed(0)}%`">
                    </b-progress-bar>
                  </b-progress> -->
                </b-tab>
              </b-tabs>

              <b-row class="justify-content-end mt-3" v-if="itemsData.length">
                <b-col lg="2" cols="4" class="mt-3">
                  <b-button @click="extractCSV_itemsData()" class="btn">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
                <template v-if="itemsData.filter(elem => elem.StateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                  <b-col lg="2" cols="4" class="mt-3">
                    <b-button @click="effacer()" class="btn">
                      {{ $t('pain008.clear_label') }}
                    </b-button>
                  </b-col>
                  <b-col lg="2" cols="4" class="mt-3">
                    <b-button @click="enregistrer()" variant="primary">
                      {{ $t('pain008.sve') }}
                    </b-button>
                  </b-col>
                </template>
              </b-row>
            </div>

            <!-- Tableau détails du fichier sélectionné -->
            <div v-else-if="currentTab === 'details'">
              <b-row class="mb-3 justify-content-between">
                <b-col lg="2" cols="4" class="mb-2" v-if="this.currentIndex > 0">
                  <b-button @click="navDetails(-1)" class="btn">
                    <i class="fa-solid fa-chevrons-left"></i>
                    {{ $t('pain008.previous') }}
                  </b-button>
                </b-col>
                <b-col lg="2" cols="4" v-if="this.currentIndex == 0 && this.itemsData.length > 1" offset="10">
                  <b-button @click="navDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
                <b-col lg="2" cols="4" class="mb-2" v-if="this.currentIndex < this.itemsData.length - 1" offset="8">
                  <div v-if="this.currentIndex > 0">
                    <b-button @click="navDetails(1)" class="btn">
                      {{ $t('pain008.next') }}
                      <i class="fa-solid fa-chevrons-right"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <b-row class="text-center mb-4">
                <b-col class="bandeau0 text-dark" style="background-color: #f1f1f1"><b>{{ $t('pain008.global_response') }}</b></b-col>
                <b-col v-if="this.itemsData[currentIndex].StateVerif === $t('pain008.positive_response')"
                  class="bandeau2" style="background-color: #47d89c!important">
                  <b>{{ this.itemsData[currentIndex].StateVerif }}</b>
                </b-col>
                <b-col v-else class="bandeau2">
                  <b>{{ this.itemsData[currentIndex].StateVerif }}</b>
                </b-col>
              </b-row>

              <div class="title-label-blue" style="width: 350px">
                {{ $t('pain008.check_bank_details') }}
              </div>
              <b-table hover fixed
                v-if="itemsData.length"
                :items="itemsDetails"
                :fields="fieldsDetails"
                :sort-by="sortField"
                ref="tablePain008DetailsClose"
                :id="'table-details' + '-' + randomString">

                <template #cell(result)="row">
                  <span v-html="row.item.result"></span>
                </template>

              </b-table>


              <form-accordion :title="$t('pain008.info_add')" :isOpen="false" :isTitleUpperCase="false">
              <b-table hover fixed
                v-if="itemsData.length"
                :items="itemsOtherDetails"
                :fields="fieldsOtherDetails"
                :sort-by="sortField"
                ref="tablePain008DetailsClose"
                :id="'table-details' + '-' + randomString">
              </b-table>
            </form-accordion>
              <template v-if="itemsData.filter(elem => elem.idrequest === request[currentIndex].idrequest && elem.StateVerif !== $t('pain008.positive_response') && elem.StatusValidation === '1').length">
                  <b-row class="justify-content-end mt-4">
                    <b-col md="2" cols="6" class="mt-3">
                      <b-button @click="refuser()" class="btn">
                        {{ $t('pain008.refus') }}
                      </b-button>
                    </b-col>
                    <b-col md="2" cols="6" class="mt-3">
                      <b-button @click="validate()" variant="primary">
                        {{ $t('pain008.validate') }}
                      </b-button>
                    </b-col>
                  </b-row>
              </template>
            </div>

            <!-- Tableau historique des modifications -->
            <!-- <div v-if="currentTab === 'historique'">

              <br />

              <b-row cols="6" >
                <b-col cols="2" v-if="this.currentIndex > 0">
                  <b-button @click="NavDetails(-1)" class="btn">
                    <i class="fa-solid fa-chevrons-left"></i>
                    {{ $t('pain008.previous') }}
                  </b-button>
                </b-col>
                <b-col cols="2" v-else offset="10">
                  <b-button @click="NavDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
                <b-col cols="2" v-if="this.currentIndex < this.itemsData.length - 1" offset="8">
                  <div v-if="this.currentIndex > 0">
                    <b-button @click="NavDetails(1)" class="btn">
                      {{ $t('pain008.next') }}
                      <i class="fa-solid fa-chevrons-right"></i>
                    </b-button>
                  </div>
                  <div v-else>
                    <b-button @click="NavDetails(1)" class="btn">
                      {{ $t('pain008.next') }}
                      <i class="fa-solid fa-chevrons-right"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <br />

              <div v-if="itemsData.length" class="title-label-blue">{{$t('pain008.history_results')}}</div>
              <b-table hover fixed
              v-if="itemsData.length"
              :items="itemsHistorique"
              :fields="fieldsHistorique"
              :sort-by="sortField"
              ref="tablePain008DetailsClose"
              :id="'table-details' + '-' + randomString">
              </b-table>

              <br />

              <b-row v-if="itemsData.length" class="justify-content-end">
                <b-col md="2">
                  <b-button v-on:click="Refuser()">
                    {{ $t('pain008.refus') }}
                  </b-button>
                </b-col>
                <b-col md="2">
                  <b-button v-on:click="Valider()" variant="primary">
                    {{ $t('pain008.validate') }}
                  </b-button>
                </b-col>
              </b-row>
            </div> -->
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'

import MessagesFilter from '@/pages/pain008/components_Traitement/'
import MessagesFilter1 from '@/pages/pain008/components_Traitement_Données/'
import pagination from '@/components/common/pagination.vue'
import pagination1 from '@/components/common/pagination.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'Consultations_Page',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-messages-filter-1': MessagesFilter1,
    'cm-pagination': pagination,
    'cm-pagination-1': pagination1,
    'form-accordion': FormAccordion,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    nbBeingProcessedRequest () {
      return !this.items[this.currentIndexList].process ? '-' : this.items[this.currentIndexList].process
    },
    nbErrorRequest () {
      return !this.items[this.currentIndexList].erro ? '-' : this.items[this.currentIndexList].erro
    },
    nbRefusedRequest () {
      return !this.items[this.currentIndexList].refus ? '-' : this.items[this.currentIndexList].refus
    },
    nbToVerifyRequest () {
      return !this.items[this.currentIndexList].verif ? '-' : this.items[this.currentIndexList].verif
    },
    nbTotalRequest () {
      return !this.items[this.currentIndexList].total ? '-' : this.items[this.currentIndexList].total
    },
    nbValidatedRequest () {
      return !this.items[this.currentIndexList].validated ? '-' : this.items[this.currentIndexList].validated
    },
    type () {
      return this.tabType === 0 ? 'PM' : 'PP'
    }
  },
  watch: {
    // whenever question changes, this function will run
    tabType(newQuestion, oldQuestion) {
      this.currentIndexList = 0
      this.showData(this.idfiledata, this.currentIndexList)
    }
  },
  data () {
    return {
      activateSpinner: false,
      allcheckedReject: false,
      allcheckedValid: false,
      completeList: [],
      currentIndex: 0,
      currentIndexHistorique: 0,
      currentIndexList: 0,
      currentTab: 'list',
      fields: [
        { key: 'fileImport', label: this.$t('pain008.nameFile'), class: 'text-left', sortable: true },
        { key: 'dateImport', label: this.$t('pain008.date_import'), class: 'text-center', sortable: true },
        // { key: 'nbTotalElem', label: this.$t('pain008.total_number_item_expect'), class: 'text-center' },
        { key: 'total', label: this.$t('pain008.total'), class: 'text-center' },
        { key: 'erro', label: this.$t('pain008.in_error'), class: 'text-center' },
        { key: 'process', label: this.$t('pain008.being_processed'), class: 'text-center' },
        { key: 'verif', label: this.$t('pain008.to_verify'), class: 'text-center' },
        { key: 'validated', label: this.$t('pain008.validated'), class: 'text-center' },
        { key: 'refus', label: this.$t('pain008.refused'), class: 'text-center' },
        { key: 'globalState', label: this.$t('pain008.stat_global'), class: 'text-center' }
      ],
      fieldsDataPM: [
        { key: 'NameAccount', label: this.$t('pain008.company_name'), class: 'text-center' },
        { key: 'Iban', label: this.$t('pain008.iban'), class: 'text-center' },
        { key: 'Siren', label: this.$t('pain008.siren'), class: 'text-center' },
        { key: 'VerifIban', label: this.$t('pain008.iban_verification'), class: 'text-center' },
        { key: 'VerifSiren', label: this.$t('pain008.siren_verification'), class: 'text-center' },
        // { key: 'Score', label: this.$t('pain008.score'), class: 'text-center' },
        { key: 'StateVerif', label: this.$t('pain008.verification_status'), class: 'text-center' },
        { key: 'ValidAll', label: this.$t('pain008.validate_all'), class: 'text-center' },
        { key: 'RejectAll', label: this.$t('pain008.decline_all'), class: 'text-center' }
      ],
      fieldsDataPP: [
        { key: 'NameAccount', label: this.$t('pain008.user_firstname_name'), class: 'text-center' },
        { key: 'Iban', label: this.$t('pain008.iban'), class: 'text-center' },
        { key: 'VerifIban', label: this.$t('pain008.iban_verification'), class: 'text-center' },
        { key: 'Score', label: this.$t('pain008.score'), class: 'text-center' },
        { key: 'StateVerif', label: this.$t('pain008.verification_status'), class: 'text-center' },
        { key: 'ValidAll', label: this.$t('pain008.validate_all'), class: 'text-center' },
        { key: 'RejectAll', label: this.$t('pain008.decline_all'), class: 'text-center' }
      ],
      fieldsDetails: [
        { key: 'field', label: this.$t('pain008.contact_details'), class: 'text-left text-green' },
        { key: 'value', label: this.$t('pain008.value'), class: 'text-center' },
        { key: 'result', label: this.$t('pain008.result_scoring_verification'), class: 'text-center' },
        { key: 'details', label: this.$t('pain008.details'), class: 'text-center' }
      ],
      fieldsDetailsControls: ['Type', 'Name', 'IBAN', 'SIREN'],
      // fieldsDetailsControls: ['Type', 'Name', 'OtherName', 'IBAN', 'BirthDate'],
      fieldsOtherDetails: [
        { key: 'Date', label: this.$t('pain008.date'), class: 'text-center'},
        { key: 'Priority', label: this.$t('pain008.priority'), class: 'text-center'},
        { key: 'Bic', label: this.$t('pain008.bic_iban_check'), class: 'text-center'},
        { key: 'Amount', label: this.$t('pain008.amount'), class: 'text-center'},
      ],
      // fieldsHistorique: [
      //   { key: 'Date', label: this.$t('pain008.date'), class: 'text-center font-weight-bold' },
      //   { key: 'TypeValue', label : this.$t('pain008.data_type'), class: 'text-center font-weight-bold'},
      //   { key: 'OldValue', label: this.$t('pain008.old_value'), class: 'text-center font-weight-bold' },
      //   { key: 'NewValue', label: this.$t('pain008.new_value'), class: 'text-center font-weight-bold' }
      // ],
      filterConditions: { Status: [] },
      get_status: [],
      idfiledata: 0,
      idrequest: [],
      items: [],
      itemsData: [],
      itemsDetails: [],
      itemsOtherDetails: [],
      max: 0,
      min: 0,
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      randomString: '',
      request: [],
      scrollFlag: true,
      serviceId: this.$engine.user.currentService.id.toString(),
      sortBy: '',
      sortDir: false,
      sortField: 'debtor_name',
      tabType: 'PM',
      value: 0
    }
  },
  created () {
    let that = this

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.reload = false
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content: start',
      navTitle: this.listTitle,
      returnUrl: ''
    })

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0

    this.paginationObject['refresh'] = 'traitement-page'
    this.$bus.$off('traitement-page')
    this.$bus.$on('traitement-page', index => {
      that.reload = true
      that.onRefresh(false, index)
      that.pageCounter = 0
    })

    // let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.getServiceIdByName(val)
    })
  },
  methods: {
    allLineSelect (decision) {
      if (decision === 'ValideAll') {
        let i = 0
        while ((i < this.itemsData.length) && (this.itemsData[i].ValidAll === true)) {
          i++
        }
        if (i === this.itemsData.length) {
          this.allcheckedValid = true
        }
      }
      else if (decision === 'RejectAll') {
        let i = 0
        while ((i < this.itemsData.length) && (this.itemsData[i].RejectAll === true)) {
          i++
        }
        if (i === this.itemsData.length) {
          this.allcheckedReject = true
        }
      }
    },
    applyFilter (filterConditions, index = 1) {
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [1,2,3,4,98,99]
      }

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
      ).then(resp => {
        if (resp.data && resp.data.Results) {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Results.length
          requests = resp.data.Results
          this.updateItems(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    applyFilterData (filterConditions) {
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      filterConditions.type = this.type

      this.allcheckedValid = false
      this.allcheckedReject = false
      this.$engine.pain08.getFileInfo(
        this.idfiledata,
        filterConditions
      ).then(resp => {
        let requests = []
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.Results.length
        requests = resp.data.Results
        this.updateItemsData(requests)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    attachInfinit () {
      this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
      this.scrollFlag = true
      this.noMore = false
    },
    choix (valid, refus) {
      let result = ''
      if (valid === true) {
        result = '2'
      } else if (refus === true) {
        result = '3'
      }
      return result
    },
    checkStatus (status) {
      if (status && (status === this.$t('pain008.file_refused') ||
      status === this.$t('pain008.lock') ||
      status === this.$t('pain008.finish'))) {
        return false
      } else {
        return true
      }
    },
    choseTable (table) {
      switch (table) {
        case 'list':
          this.currentTab = 'list'
          this.onRefresh()
          break
        case 'data':
          this.currentTab = 'data'
          break
        case 'details':
          this.currentTab = 'details'
          break
        case 'historique':
          this.currentTab = 'historique'
          break
        default:
          this.currentTab = 'list'
          break
      }
    },
    cloturer (idFile) {
      let status = 5
      this.idfiledata = idFile
      this.$engine.pain08.updateCloturer(this.idfiledata, status)
      this.onRefresh()
    },
    convertTime (time) {
      return (moment(time).format('DD/MM/YYYY [à] HH[h]mm'))
    },
    // dateScore (requests) {
    //   let score = 0
    //   let i = 0
    //   let str = requests.split(',')
    //   while(str[i]) {
    //     if( (str[i] >= "09000" && str[i] <= "09400") || (str[i] >= "10000" && str[i] <= "10400") ) {
    //       score = str[i].slice(2)
    //     }
    //     i++
    //   }
    //   return score
    // },
    decideLine (row, decision) {
      if (this.allcheckedValid && decision === 1) {
        this.allcheckedValid = false
      } else if (this.allcheckedValid && decision === 0) {
        this.allcheckedValid = false
      } else if (this.allcheckedReject && decision === 1) {
        this.allcheckedReject = false
      } else if (this.allcheckedReject && decision === 0) {
        this.allcheckedReject = false
      }

      if(decision === 0) {
        row.item.ValidAll = false
      } else if (decision === 1) {
        row.item.RejectAll = false
      }
      this.allLineSelect('ValideAll')
      this.allLineSelect('RejectAll')
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    effacer () {
      this.allcheckedReject = false
      this.allcheckedValid = false
      for (let index = 0; index < this.itemsData.length; index++) {
          this.itemsData[index].ValidAll = false
          this.itemsData[index].RejectAll = false
      }
    },
    enregistrer () {
      let result = []
      for (let index = 0; index < this.itemsData.length; index++) {
        let action = {
          idrequest: this.idrequest[index],
          choice: this.choix(this.itemsData[index].ValidAll, this.itemsData[index].RejectAll)
        }
        if (action.choice !== '') {
          result.push(action)
        }
      }
      //let that = this
      let nbValidated = result.filter(elem => elem.choice === '2').length
      let nbRefused = result.filter(elem => elem.choice === '3').length
      // if (this) {
      //   console.log('result', result)
      //   console.log('nb validé', result.filter(elem => elem.choice === '4').length)
      //   console.log('nb refusés', result.filter(elem => elem.choice === '3').length)
      //   return
      // }
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].validated === "-") {
          this.items[this.currentIndexList].validated = 0
        } if (this.items[this.currentIndexList].refus === "-") {
          this.items[this.currentIndexList].refus = 0
        } if (this.items[this.currentIndexList].verif === "-") {
          this.items[this.currentIndexList].verif = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].validated += nbValidated
        this.items[this.currentIndexList].refus += nbRefused
        this.showData(this.idfiledata, this.currentIndexList)
      })

      this.showData(this.idfiledata, this.currentIndexList)
    },
    extractCSV_items () {
      let filterConditions
      if (this.reload) {
        filterConditions =
          this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions =
          this.$engine.pain08.filter.getDefaultFilter()
      }

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [1,2,3,4,98,99]
      }

      this.$engine.pain08.update(filterConditions).then(resp => {
        let requests = {}
        requests = resp.data.Results
        //this.updateItems(requests)
        this.extractData(requests)
        this.currentTab = 'list'

        //this.activateSpinner = false
      })
      .catch(error => {
        //this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    extractData (requests) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      firstLine = this.$t('pain008.nameFile') + ';' +
        this.$t('pain008.date_import') + ';' +
        this.$t('pain008.total') + ';' +
        this.$t('pain008.in_error') + ';' +
        this.$t('pain008.being_processed') + ';' +
        this.$t('pain008.to_verify') + ';' +
        this.$t('pain008.validated') + ';' +
        this.$t('pain008.refused') + ';' +
        this.$t('pain008.stat_global') + '\r\n'
      fileName = 'importedFilesList' + today.unix() + '.csv'

      for (let k in requests) {

        let dateImport = ''
        dateImport = requests[k].DateImport

        if (dateImport !== '') {
          dateImport = this.convertTime(dateImport)
        }

        let globalState = ''
        globalState = requests[k].Status
        if (globalState !== '') {
          globalState = this.globalState(globalState)
        }

        lines += requests[k].NameFile + ';' +
        dateImport + ';' +
        requests[k].NbTotal + ';' +
        requests[k].NbError + ';' +
        requests[k].NbBeingProcessed + ';' +
        requests[k].NbVerify + ';' +
        requests[k].NbValide + ';' +
        requests[k].NbReject + ';' +
        globalState + '\r\n'
      }
      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    extractCSV_itemsData () {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      firstLine = this.$t('pain008.user_firstname_name') + ';' +
        this.$t('pain008.iban') + ';' +
        this.$t('pain008.siren') + ';' +
        this.$t('pain008.iban_verification') + ';' +
        this.$t('pain008.siren_verification') + ';' +
        // this.$t('pain008.score') + ';' +
        this.$t('pain008.verification_status') + '\r\n'
        // this.$t('pain008.validate_all') + ';' +
        // this.$t('pain008.decline_all') + '\r\n'
      fileName = 'selectedFileData' + today.unix() + '.csv'
      for (let k in this.itemsData) {
        let iconVerifIban
        if (this.itemsData[k].VerifIban === "<i class='fa-solid fa-check text-success'></i>") {
          iconVerifIban = this.$t('pain008.validated_2')
        } else if (this.itemsData[k].VerifIban === "<i class='fa-solid fa-xmark text-danger'></i>") {
          iconVerifIban = this.$t('pain008.refused_2')
        } else if (this.itemsData[k].VerifIban === "<i class='fa-solid fa-location-exclamation'></i>") {
          iconVerifIban = this.$t('pain008.not_validated')
        } else {
          iconVerifIban = "-"
        }


        let iconVerifSiren
        if (this.itemsData[k].VerifSiren === "<i class='fa-solid fa-check text-success'></i>") {
          iconVerifSiren = this.$t('pain008.validated_2')
        } else if (this.itemsData[k].VerifSiren === "<i class='fa-solid fa-xmark text-danger'></i>") {
          iconVerifSiren = this.$t('pain008.refused_2')
        } else if (this.itemsData[k].VerifSiren === "<i class='fa-solid fa-location-exclamation'></i>") {
          iconVerifSiren = this.$t('pain008.not_validated')
        } else {
          iconVerifSiren = "-"
        }

        lines += this.itemsData[k].NameAccount + ';' +
        this.itemsData[k].Iban + ';' +
        this.itemsData[k].Siren + ';' +
        iconVerifIban + ';' +
        iconVerifSiren + ';' +
        // this.itemsData[k].Score + ';' +
        this.itemsData[k].StateVerif + '\r\n'
        // this.itemsData[k].ValidAll + ';' +
        // this.itemsData[k].RejectAll + '\r\n'
      }
      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    globalState (request) {
      let status_label = ''
      if(request === '1') {
        status_label = this.$t('pain008.processed_pending')
      } else if (request === '2') {
        status_label = this.$t('pain008.registered')
      } else if (request === '3') {
        status_label = this.$t('pain008.file_refused')
      } else if (request === '4') {
        status_label = this.$t('pain008.waiting_decision_2')
      } else if (request === '5') {
        status_label = this.$t('pain008.finish')
      } else if (request === '6') {
        status_label = this.$t('pain008.state_closed')
      // } else if (request === '7') {
      //   status_label = this.$t('pain008.partially_treaty')
      } else if (request === '98') {
        status_label = this.$t('pain008.eligible_reconstruction')
      } else if (request === '99') {
        status_label = this.$t('pain008.lock')
      }
      return status_label
    },
    navDetails (index) {
      console.log('currentIndex', this.currentIndex)
      let new_index = index + this.currentIndex
      this.showDetails(new_index)
    },
    onRefresh (noAttach = false, index = 1) {

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pain08.filter.getDefaultFilter()
      }

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [1,2,3,4,98,99]
      }

      //filterConditions.IdFile = '20'

      // filterConditions.sortField = 'SF' + this.sortField
      // filterConditions.sortDirection = this.sortDirection

      // let that = this

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex
      ).then(resp => {
        if (resp.data && resp.data) {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Results.length
          requests = resp.data.Results
          this.updateItems(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.currentTab = 'list'

        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    progressBar (index) {
      this.value = this.items[index].verif
      this.max = this.items[index].total
    },
    refreshInbox () {
      this.onRefresh()
    },
    refuser () {
      let result = []
      let action = {
          idrequest: this.idrequest[this.currentIndex],
          choice: '3'
      }
      result.push(action)
      let nbRefused = result.filter(elem => elem.choice === '3').length
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].refus === "-") {
          this.items[this.currentIndexList].refus = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].refus += nbRefused
      })
      this.showData(this.idfiledata, this.currentIndexList)
    },
    selectAll (decision) {
      for (let index = 0; index < this.itemsData.length; index++) {
        if(decision === 'ValideAll') {
          this.allcheckedReject = false
          this.itemsData[index].ValidAll = (this.allcheckedValid) ? true : false
          this.itemsData[index].RejectAll = false
        } else if (decision === 'RejectAll') {
          this.allcheckedValid = false
          this.itemsData[index].ValidAll = false
          this.itemsData[index].RejectAll = (this.allcheckedReject) ? true : false
        }
      }
    },
    showData (id, index) {
      this.activateSpinner = true

      this.allcheckedValid = false
      this.allcheckedReject = false
      this.currentIndexList = index
      this.idfiledata = id
      let that = this

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.$engine.pain08.getFileInfo(id, {Type: this.type})
      .then(resp => {
        let requests = []
        if (resp && resp.data) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults

          that.paginationObject.nbResults = resp.data.Results.length

          requests = resp.data.Results
          this.request = requests
          that.updateItemsData(requests)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', this.paginationObject)

          that.currentTab = 'data'
          this.progressBar(index)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    showDetails (index) {
      this.currentIndex = index

      let dateImport = ''
      dateImport = this.request[this.currentIndex].Date

      let priorityStatus = ''
      priorityStatus = this.request[this.currentIndex].Priorite

      if (priorityStatus == 1) {
        priorityStatus = this.$t('pain008.high')
      }

      this.itemsOtherDetails = []
      if (dateImport !== '') {
        dateImport = this.convertTime(dateImport)
        this.itemsOtherDetails.push({
          Date: dateImport,
          Priority: priorityStatus,
          Bic: this.request[this.currentIndex].Bic,
          Amount: this.request[this.currentIndex].InstdAmt + " €"

        })
      }
      let result = this.request[index]
      this.updateItemsDetails(result)
      this.currentTab = 'details'
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateInbox (requests, noAttach = false) {
      this.itemsData = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {
        let DetailsOK = []
        let DetailsKO = []
        if (requests[i].DetailsOK) {
          for (var j = 0; j < requests[i].DetailsOK.length; j++) {
            let dateimportOK = requests[i].DetailsOK[j].dateimport
            if (dateimportOK) {
              dateimportOK = this.convertTime(dateimportOK)
            }
            let detailsOK = {
              namefile: requests[i].DetailsOK[j].namefile,
              dateimport: dateimportOK,
              nblignes: requests[i].DetailsOK[j].nblignes
            }
            DetailsOK.push(detailsOK)
          }

          for (var z = 0; z < requests[i].DetailsKO.length; z++) {
            let dateimportKO = requests[i].DetailsKO[z].dateimport
            if (dateimportKO) {
              dateimportKO = this.convertTime(dateimportKO)
            }
            let detailsKO = {
              namefile: requests[i].DetailsKO[z].namefile,
              dateimport: dateimportKO,
              nblignes: requests[i].DetailsKO[z].nblignes
            }
            DetailsKO.push(detailsKO)
          }
        }

        let dateImport = ''
        dateImport = requests[i].DateImport

        if (dateImport !== '') {
          dateImport = this.convertTime(dateImport)
        }

        let globalState = ''
        globalState = requests[i].Status
        if (globalState !== '') {
          globalState = this.globalState(globalState)
        }

        let result = {
          IdFile: requests[i].IdFile === '' ? '-' : requests[i].IdFile,
          fileImport: requests[i].NameFile === '' ? '-' : requests[i].NameFile,
          dateImport: dateImport === '' ? '-' : dateImport,
          total: requests[i].NbTotal === '0' ? '-' : parseInt(requests[i].NbTotal),
          erro: requests[i].NbError === '0' ? '-' : parseInt(requests[i].NbError),
          validated: requests[i].NbValide === '0' ? '-' : parseInt(requests[i].NbValide),
          verif: requests[i].NbVerify === '0' ? '-' : parseInt(requests[i].NbVerify),
          refus: requests[i].NbReject === '0' ? '-' : parseInt(requests[i].NbReject),
          process: requests[i].NbBeingProcessed === '0' ? '-' : parseInt(requests[i].NbBeingProcessed),
          globalState: globalState,
          detailsOK : DetailsOK,
          detailsKO: DetailsKO
        }
        this.items.push(result)
        // DDE - 10/02/2023 on exclut les fichiers clos et les fichiers terminés de la liste
        this.items = this.items.filter(item => item.globalState != this.$t('pain008.state_closed') && item.globalState != this.$t('pain008.finish'))
      }
    },
    updateItemsData (requests) {
     this.itemsData = []
     this.idrequest = []
     for (var i = 0; i < requests.length; i++) {
      this.idrequest.push(requests[i].idrequest)
      let result = {
        NameAccount: requests[i].Name,
        Iban: requests[i].IBAN === '' ? '-' : requests[i].IBAN,
        Siren: requests[i].SIREN === '' ? '-' : requests[i].SIREN,
        VerifIban: this.verifIban(requests[i].ReturnCode) === '' ? '-' : this.verifIban(requests[i].ReturnCode),
        VerifSiren: this.verifSiren(requests[i].ReturnCode) === '' ? '-' : this.verifSiren(requests[i].ReturnCode),
        StatusValidation: requests[i].StatusValidation,
        idrequest: requests[i].idrequest,
        // Score: this.dateScore(requests[i].ReturnCode) === '' ? '-' : this.dateScore(requests[i].ReturnCode),
        StateVerif: this.verifStatus(requests[i].Verification),
        ValidAll: false,
        RejectAll: false
       }
       this.itemsData.push(result)
      }
     },
     updateItemsDetails (request) {
      this.itemsDetails = []
      for (let x = 0; x < this.fieldsDetailsControls.length; x++) {
        let field = this.fieldsDetailsControls[x]
        let value = request[field]
        let result = ''
        switch (field) {
          case 'IBAN': // 01xxx
            result = this.verifIban(request.ReturnCode)
            break
          case 'SIREN': // 03xxx
            result = this.verifSiren(request.ReturnCode)
            break
          case 'Type': // 02xxx
            result = this.verifType(request.ReturnCode)
            break
          case 'BirthDate': // 06xxx
            result = this.verifBirthDate(request.ReturnCode)
            break
          case 'Name': // 09xxx
            result = this.verifName(request.ReturnCode)
            break
          case 'OtherName': // 10xxx
            result = this.verifOtherName(request.ReturnCode)
            break
          default:
            break
        }
        if (field === 'Type') {
          value = this.$t('pain008.' + value)
        }
        if (field === 'BirthDate') {
          value = moment(value).format('DD/MM/YYYY')
        }
        this.itemsDetails.push({
          field: this.$t('pain008.fields.' + field),
          value: value,
          result: result,
          details: this.verifALL(request.ReturnCode, field)
        })
      }
    },
    validate () {
      let result = []
      let action = {
          idrequest: this.idrequest[this.currentIndex],
          choice: '2'
      }
      result.push(action)
      let nbValidated = result.filter(elem => elem.choice === '2').length
      this.$engine.pain08.updateDecision(this.idfiledata, result)
      .then((resp) => {
        if (this.items[this.currentIndexList].validated === "-") {
          this.items[this.currentIndexList].validated = 0
        }
        this.items[this.currentIndexList].verif -= result.length
        this.items[this.currentIndexList].validated += nbValidated
      })
      this.showData(this.idfiledata, this.currentIndexList)
    },
    verifALL (requests, j) {
      let details = ''
      let str = requests.split(',')
      let i = 0
      while(str[i]) {
        if (j === 'IBAN') {
          switch(str[i]) {
            case '01000':
              details = 'Faux'
              break
            case '01001':
              details = 'Vrai'
              break
            case '01010':
              details = this.$t('pain008.closed_account')
              break
            case '01030':
              details = this.$t('pain008.non_existing_account')
              break
            case '01040':
              details = this.$t('pain008.account_out_of_scope')
              break
            default:
              break
          }
        } if (j === 'SIREN') {
          switch(str[i]) {
            case '03000':
              details = 'Faux'
              break
            case '03001':
              details = 'Vrai'
              break
            case '03020':
              details = this.$t('pain008.control_not_possible')
              break
            default:
              break
          }
        } if (j === 'Type') {
          switch(str[i]) {
            case '02000':
              details = 'Faux'
              break
            case '02001':
              details = 'Vrai'
              break
            default:
              break
          }
        }
        // if (j === 'BirthDate' && str[i] === '06020') {
        //   details = 'Faux - Impossible de vérifier la date de naissance'
        // } if (j === 'BirthDate' && str[i] === '06000') {
        //   details = 'Faux - Date de naissance incorrect'
        // } if (j === 'Type' && str[i] === '02000') {
        //   details = 'Faux - Type de titulaire incorrect'
        // } if (j === 'Name' && this.verifName(requests) > 'value acceptance') {
        //   details = 'Faux - '
        // } if (j === 'OtherName' && this.verifOtherName(requests) > 'value acceptance') {
        //   details = 'Faux - '
        // }
        i++
      }
      return details
    },
    // verifBirthDate (requests) {
    //   let verif = "<i class='fa-solid fa-xmark text-danger'></i>"
    //   let str = requests.split(',')
    //   let i = 0
    //   while(str[i]) {
    //     if(str[i] == "06001") {
    //       verif = "<i class='fa-solid fa-check text-success'></i>"
    //     }
    //     i++
    //   }
    //   return verif
    // },
    verifIban (requests) {
      let verif = ""
      let str = requests.split(',')
      let i = 0
      while (str[i]) {
        if (str[i] == "01001") {
          verif = "<i class='fa-solid fa-check text-success'></i>"
        } else if (str[i] == "01000") {
          verif = "<i class='fa-solid fa-xmark text-danger'></i>"
        } else if ((str[i] == "01010") || (str[i] == "01030") || (str[i] == "01040")) {
          verif = "<i class='fa-solid fa-location-exclamation'></i>"
        }
        i++
      }
      return verif
    },
    verifSiren (requests) {
      let verif = ""
      let str = requests.split(',')
      let i = 0
      while (str[i]) {
        if (str[i] == "03001") {
          verif = "<i class='fa-solid fa-check text-success'></i>"
        } else if (str[i] == "03000") {
          verif = "<i class='fa-solid fa-xmark text-danger'></i>"
        } else if (str[i] == "03020") {
          verif = "<i class='fa-solid fa-location-exclamation'></i>"
        }
        i++
      }
      return verif
    },
    verifName (requests) {
      // let verif = "<i class='fa-solid fa-xmark text-danger'></i>"
      // let str = requests.split(',')
      // let i = 0
      // while(str[i]) {
      //   if (str[i] >= "09000" && str[i] <= "09400") {
      //     verif = str[i].slice(2)
      //   }
      //   i++
      // }
      // return verif
    },
    verifOtherName (requests) {
      // let verif = "<i class='fa-solid fa-xmark text-danger'></i>"
      // let str = requests.split(',')
      // let i = 0
      // while(str[i]) {
      //   if(str[i] >= "10000" && str[i] <= "10400") {
      //     verif = str[i].slice(2)
      //   }
      //   i++
      // }
      // return verif
    },
    verifStatus (request) {
      let result = ''
      if(request === '10') {
        result = this.$t('pain008.positive_response')
      } if(request === '2') {
        result = this.$t('pain008.request_being_processed')
      } if(request === '11') {
        result = this.$t('pain008.negative_response')
      } if(request === '12') {
        result = this.$t('pain008.expired_request')
      } if(request === '6') {
        result = this.$t('pain008.bank_unreachable')
      }
      return result
    },
    verifType (requests) {
      let verif = ""
      let str = requests.split(',')
      let i = 0
      while(str[i]) {
        if(str[i] == "02001") {
          verif = "<i class='fa-solid fa-check text-success'></i>"
        } else if(str[i] == "02000") {
          verif = "<i class='fa-solid fa-xmark text-danger'></i>"
        }
        i++
      }
      return verif
    },
    updateList (requests) {
      this.completeList = requests
    }
  }
}

</script>
